import React, { Fragment } from 'react';
import { Button, Form, Grid, Icon, Label, Loader, Popup, Table } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { fetchMarks } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class StudentGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            grades: {},
            gradesArray: [],
            mark: null,

            loading: true,
            confirmation: false,

            semesters: [],
            semester: null,
            semesterEdit: false,
            fixCourseImplLoading: false,

            dateEdit: false,
            examDate: null,
            fixCourseImplRowLoading: null,
            fixCourseImplNppRowLoading: null,
        };
        this.deleteMark = this.deleteMark.bind(this);
        this.getGrade = this.getGrade.bind(this);
        this.editGrade = this.editGrade.bind(this);
        this.getMarkLookup = this.getMarkLookup.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.getGrade();
        if (localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') {
            this.getMarkLookup();
            this.getSemesterLookup();
        }
    }

    getSemesterLookup() {
        axios.get('/study-program-semesters')
            .then((response) => {
                const semesters = response.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: `${el.id} (${el.name})`
                }));
                this.setState({
                    semesters
                });
            })
            .catch((error) => {
                console.log('Error fetching semesters', error);
            });
    }

    editSemester(semesterId, markId) {
        this.setState({ loaderForEditing: true });
        axios.put(`/student-exams/set-study-program-plan-semester/${markId}/${semesterId}`)
            .then((response) => {
                const success = response.data;
                if (success) {
                    toast('Uspješno ste izmijenili semestar.');
                    this.setState({
                        semester: null,
                        semesterEdit: false,
                        currentMarkId: -1,
                        loaderForEditing: false
                    });
                    this.getGrade();
                } else {
                    toast('Došlo je do greške.');
                }
            })
            .catch((error) => {
                this.setState({ loaderForEditing: false });
                toast('Došlo je do greške.');
            });
    }

    getMarkLookup() {
        fetchMarks()
            .then(res => {
                const marks = res.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName),
                    passed: el.passed,
                    key_: el._key,
                    letter: el.letter
                }));
                this.setState({
                    marks
                });
            })
            .catch(err => {
                console.log('Failed to fetch lkp marks!');
            });
    }

    getGrade() {
        axios.get(`/student-exams/grades/${this.props.studentId}`)
            .then(res => {
                const grades = res.data;
                const gradesArray = res.data.grades;
                this.setState({
                    grades,
                    gradesArray,
                    loading: false,
                    average: grades.gradeAverage
                });
            })
            .catch(err => {
                console.log('Failed to fetch student grades');
            });
    }

    editGrade(mark) {
        let obj = {
            studentMarkId: mark.id,
            optLock: mark.optLock,
            markId: this.state.mark

        };
        axios.put('grade-student/edit-grade', { ...obj })
            .then(res => {
                toast('Uspješno ste izmijenili ocjenu.');
                this.getGrade();
                this.setState({
                    mark: null,
                    loaderForEditing: false,
                    edit: false,
                    dateEdit: false,
                    currentMarkId: -1
                });
            })
            .catch(err => {
                this.setState({ loaderForEditing: false });
                if (err.response.data === 'Student mark has been already changed!') {
                    toast('Ocjena je već izmijenjena. Pokušajte ponovo.');
                } else if (err.response.data === 'Could not edit date and mark for passed student mark!') {
                    toast('Nije moguće mijenjati datum ocjene.');
                } else {
                    toast('Došlo je do greške.');
                }
            });
    }

    editExamDate(date, markId) {
        const timestamp = new Date(date).getTime();
        this.setState({ loaderForEditing: true });

        axios.put(`/student-exams/set-exam-date/${markId}/${timestamp}`)
            .then(() => {
                toast('Uspješno ste izmijenili datum ispita!');
                this.getGrade();
                this.setState({
                    dateEdit: false,
                    examDate: null,
                    currentMarkId: -1,
                    loaderForEditing: false
                });
            })
            .catch(err => {
                this.setState({ loaderForEditing: false });
                if (err.response && err.response.data) {
                    toast(err.response.data, 'error');
                } else {
                    toast('Greška prilikom izmjene datuma!', 'error');
                }
            });
    }

    handleInputChange(event, {
        name,
        value
    }) {
        this.setState({
            [name]: value
        });
    }

    deleteMark(markId, optLock) {
        let obj = {
            id: markId,
            optLock
        };
        axios.delete(`/grade-student/delete-grade/${this.props.studentId}/`, { data: obj })
            .then((res) => {
                this.setState({
                    loader: false,
                    loaderForEditing: false,
                    confirmation: false
                });
                toast('Uspješno ste izbrisali ocjenu!');
                this.getGrade();
            })
            .catch(err => {
                this.setState({
                    loader: false,
                    loaderForEditing: false,
                    confirmation: false
                });
                if (err.response.data === 'Student mark is changed!') {
                    toast('Ocjena je izmijenjena u međuvremenu. Pokušajte ponovo!');
                } else {
                    toast('Došlo je do greške! Ocjena nije izbrisana!');
                }
            });
    }

    fixCourseImplementations() {
        this.setState({ fixCourseImplLoading: true });
        axios.post(`/students/fix-course-implementations/ssp/${this.props.studentId}`)
            .then((res) => {
                this.setState({ fixCourseImplLoading: false });
                const fixedCourseNames = res.data || [];
                if (fixedCourseNames.length) {
                    toast(
                        <div>
                            Uspješno izvršena korekcija implementacija za sljedeće predmete:
                            <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px' }}>
                                {fixedCourseNames.map((name, index) => (
                                    <li key={index}>{name}</li>
                                ))}
                            </ul>
                        </div>
                    );
                } else {
                    toast('Korekcija implementacija predmeta izvršena, nije bilo predmeta za ispravku.');
                }
                this.getGrade();
            })
            .catch(() => {
                this.setState({ fixCourseImplLoading: false });
                toast('Došlo je do greške pri korekciji implementacija predmeta.');
            });
    }

    fixCourseImplementationForMark(studentMarkId) {
        this.setState({ fixCourseImplRowLoading: studentMarkId });
        axios.post('/students/fix-course-implementations/student-marks', [studentMarkId])
            .then(() => {
                this.setState({ fixCourseImplRowLoading: null });
                toast('Uspješno izvršena korekcija implementacije predmeta.');
                this.getGrade();
            })
            .catch(() => {
                this.setState({ fixCourseImplRowLoading: null });
                toast('Došlo je do greške pri korekciji implementacije predmeta.');
            });
    }

    fixCourseImplementationNppForMark(studentMarkId) {
        this.setState({ fixCourseImplNppRowLoading: studentMarkId });
        axios.post('/students/fix-course-implementations-npp/student-marks', [studentMarkId])
            .then(() => {
                this.setState({ fixCourseImplNppRowLoading: null });
                toast('Uspješno izvršena korekcija implementacije predmeta (NPP).');
                this.getGrade();
            })
            .catch(() => {
                this.setState({ fixCourseImplNppRowLoading: null });
                toast('Došlo je do greške pri korekciji implementacije predmeta (NPP).');
            });
    }

    render() {
        const localStorageRole = localStorage.getItem('activeRole');
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isAdminOnly = localStorageRole === 'Administrator';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        if (this.state.loading) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active/></div>;
        }


        const {
            grades,
            gradesArray,
            average
        } = this.state;
        const { locked } = JSON.parse(localStorage.getItem('student'));
        return (
            <div>
                {this.state.loader && <Loader active inline="centered"/>}
                {gradesArray.length ?
                    <Table structured celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="5">Predmet</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Profesor</Table.HeaderCell>
                                {/* <Table.HeaderCell>Semestar</Table.HeaderCell> */}
                                <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>
                                    {'Datum ispita'}
                                    <div style={{
                                        fontSize: '0.85em',
                                        color: '#999'
                                    }}>
                                        {'Datum unosa ocjene'}
                                    </div>
                                </Table.HeaderCell>
                                {isAdmin && <Table.HeaderCell colSpan="2">Semestar</Table.HeaderCell>}
                                <Table.HeaderCell colSpan={'2'}>Ocjena</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body> {gradesArray.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell colSpan="5" verticalAlign="middle">
                                    <Grid columns={1} centered stackable>
                                        <Grid.Column width="12">
                                            {el.courseName}
                                        </Grid.Column>
                                        <Grid.Column width="4" verticalAlign="middle" textAlign="right">
                                            <span>
                                                {el.examRecognition &&
                                                    <Popup content="Priznavanje" hideOnScroll position="top center"
                                                           trigger={<Label size="tiny" as="a" basic><span><Icon
                                                               name="check" color="blue"/></span></Label>}/>}
                                                {el.courseEquivalence &&
                                                    <Popup content="Ekvivalencija" hideOnScroll position="top center"
                                                           trigger={<Label size="tiny" as="a" basic><span><Icon
                                                               name="exchange" color="blue"/></span></Label>}/>}
                                                {el.mobilityGrade &&
                                                    <Popup content="Mobilnost" hideOnScroll position="top center"
                                                           trigger={<Label size="tiny" as="a" basic><span><Icon
                                                               name="sync alternate" color="blue"/></span></Label>}/>}
                                                {isAdmin &&
                                                    <Popup
                                                        content="Korekcija implementacije predmeta"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                circular
                                                                loading={this.state.fixCourseImplRowLoading === el.id}
                                                                disabled={this.state.fixCourseImplRowLoading !== null}
                                                                color="orange"
                                                                icon="wrench"
                                                                size="mini"
                                                                onClick={() => this.fixCourseImplementationForMark(el.id)}
                                                            />
                                                        }
                                                    />
                                                }
                                                {isAdminOnly &&
                                                    <Popup
                                                        content="Korekcija implementacije predmeta (NPP)"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                circular
                                                                loading={this.state.fixCourseImplNppRowLoading === el.id}
                                                                disabled={this.state.fixCourseImplNppRowLoading !== null}
                                                                color="teal"
                                                                icon="sitemap"
                                                                size="mini"
                                                                onClick={() => this.fixCourseImplementationNppForMark(el.id)}
                                                            />
                                                        }
                                                    />
                                                }
                                            </span>
                                        </Grid.Column>
                                    </Grid>
                                    {(isAdmin || isStudentService) &&
                                        <div style={{
                                            fontSize: '0.85em',
                                            color: '#999'
                                        }}>
                                            {el.courseBasicComment}
                                        </div>
                                    }
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width={3}>
                                    {el.teacher}
                                </Table.Cell>
                                {/* <Table.Cell verticalAlign="middle"> */}
                                {/* {el.semester} */}
                                {/* </Table.Cell> */}
                                <Table.Cell verticalAlign="middle">
                                    {el.ects}
                                </Table.Cell>
                                <Table.Cell colSpan="2" verticalAlign="middle">
                                    {
                                        this.state.dateEdit && this.state.currentMarkId === el.id
                                            ?
                                            <div>
                                                <div>
                                                    <Form.Field>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            placeholder="Odaberite datum"
                                                            disabled={this.state.loaderForEditing}
                                                            value={this.state.examDate ? new Date(this.state.examDate) : new Date(el.examDate)}
                                                            onChange={(value) => {
                                                                this.setState({ examDate: value });
                                                            }}
                                                            fluid
                                                        />
                                                    </Form.Field>
                                                </div>
                                                <div style={{
                                                    textAlign: 'center',
                                                    marginTop: '5px'
                                                }}>
                                                    <Popup
                                                        content="Sačuvaj"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                loading={this.state.loaderForEditing}
                                                                circular
                                                                size="mini"
                                                                color="blue"
                                                                icon="check"
                                                                onClick={() => {
                                                                    this.editExamDate(this.state.examDate, el.id);
                                                                }}
                                                            />}
                                                    />
                                                    <Popup
                                                        content="Odustani"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                disabled={this.state.loaderForEditing}
                                                                circular
                                                                size="mini"
                                                                color="red"
                                                                icon="close"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        dateEdit: false,
                                                                        examDate: null,
                                                                        currentMarkId: -1,
                                                                    });
                                                                }}
                                                            />}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                <div>
                                                    <div>{moment(el.examDate)
                                                        .format('D. M. YYYY.')}</div>
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        {el.inputDate ? moment(el.inputDate)
                                                            .format('D. M. YYYY.') : ''}
                                                    </div>
                                                </div>
                                                {isAdmin &&
                                                    <Popup
                                                        content="Izmjena datuma"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                disabled={
                                                                    el.mobilityGrade ||
                                                                    el.examRecognition ||
                                                                    el.courseEquivalence ||
                                                                    this.state.edit ||
                                                                    this.state.semesterEdit ||
                                                                    (this.state.dateEdit && this.state.currentMarkId !== el.id)
                                                                }
                                                                basic
                                                                circular
                                                                icon="pencil"
                                                                size="mini"
                                                                color="green"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        currentMarkId: el.id,
                                                                        dateEdit: true
                                                                    });
                                                                }}
                                                            />
                                                        }
                                                    />
                                                }
                                            </div>
                                    }
                                </Table.Cell>
                                {isAdmin && <Table.Cell colSpan="2" verticalAlign="middle">
                                    {
                                        this.state.semesterEdit && this.state.currentMarkId === el.id
                                            ?
                                            <div>
                                                <div>
                                                    <Form.Field>
                                                        <Form.Dropdown
                                                            disabled={this.state.loaderForEditing}
                                                            selection
                                                            options={this.state.semesters}
                                                            onChange={this.handleInputChange}
                                                            value={this.state.semester ? this.state.semester : el.semesterNumber}
                                                            name="semester"
                                                            placeholder="Odaberite semestar"
                                                            search
                                                            fluid
                                                        />
                                                    </Form.Field>
                                                </div>
                                                <div style={{
                                                    textAlign: 'center',
                                                    marginTop: '5px'
                                                }}>
                                                    <Popup
                                                        content="Sačuvaj"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                loading={this.state.loaderForEditing}
                                                                circular
                                                                size="mini"
                                                                color="blue"
                                                                icon="check"
                                                                onClick={() => {
                                                                    this.editSemester(this.state.semester, el.id);
                                                                }}
                                                            />}
                                                    />
                                                    <Popup
                                                        content="Odustani"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                disabled={this.state.loaderForEditing}
                                                                circular
                                                                size="mini"
                                                                color="red"
                                                                icon="close"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        semesterEdit: false,
                                                                        currentMarkId: -1,
                                                                        semester: null,
                                                                        dateEdit: false,
                                                                    });
                                                                }}
                                                            />}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                {el.semesterNumber ? `${el.semesterNumber} (${el.semester})` : '-'}
                                                <Popup
                                                    content="Izmjena semestra"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={
                                                                el.mobilityGrade ||
                                                                el.examRecognition ||
                                                                el.courseEquivalence ||
                                                                this.state.edit ||
                                                                this.state.dateEdit ||
                                                                (this.state.semesterEdit && this.state.currentMarkId !== el.id)
                                                            }
                                                            basic
                                                            circular
                                                            icon="pencil"
                                                            size="mini"
                                                            color="green"
                                                            onClick={() => {
                                                                this.setState({
                                                                    currentMarkId: el.id,
                                                                    semesterEdit: true
                                                                });
                                                            }}
                                                        />
                                                    }
                                                />
                                            </div>
                                    }
                                </Table.Cell>}
                                <Table.Cell colSpan={'2'} verticalAlign="middle">
                                    <div>
                                        {this.state.edit && this.state.currentMarkId === el.id ?
                                            <div>
                                                <div>
                                                    <Form.Field>
                                                        <Form.Dropdown
                                                            selection
                                                            options={this.state.marks.filter(el => (el.key_ !== 'nz' && el.key_ !== 'no' && el.key_ !== 'not_defended'))}
                                                            onChange={this.handleInputChange}
                                                            value={this.state.mark ? this.state.mark : el.markId}
                                                            name="mark"
                                                            placeholder="Odaberite ocjenu"
                                                            search
                                                            fluid
                                                        />
                                                    </Form.Field>
                                                </div>
                                                <div style={{
                                                    textAlign: 'center',
                                                    marginTop: '5px'
                                                }}>
                                                    <Fragment>
                                                        <Popup
                                                            content="Sačuvaj"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    loading={this.state.loaderForEditing}
                                                                    basic="true"
                                                                    circular
                                                                    size="mini"
                                                                    color="blue"
                                                                    icon="check"
                                                                    onClick={() => {
                                                                        this.setState({ loaderForEditing: true });
                                                                        this.editGrade(el);
                                                                    }}
                                                                />}
                                                        />
                                                        <Popup
                                                            content="Odustani"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    basic="true"
                                                                    circular
                                                                    size="mini"
                                                                    color="red"
                                                                    icon="close"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            edit: false,
                                                                            currentMarkId: -1
                                                                        });
                                                                    }}
                                                                />}
                                                        />
                                                    </Fragment>
                                                </div>
                                            </div>
                                            :
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                {el.mark}
                                                {!locked && <div>
                                                    {isAdmin && <Popup
                                                        content="Izmjena ocjene"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                disabled={el.mobilityGrade || el.examRecognition || el.courseEquivalence || this.state.dateEdit || this.state.semesterEdit || (this.state.edit && this.state.currentMarkId !== el.id)}
                                                                basic="true"
                                                                circular
                                                                icon="pencil"
                                                                size="mini"
                                                                color="green"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        currentMarkId: el.id,
                                                                        edit: true
                                                                    });
                                                                }}
                                                            />}
                                                    />}
                                                    {this.props.thirdCycle && isStudentService && <Popup
                                                        content="Brisanje"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                disabled={el.mobilityGrade || el.examRecognition || el.courseEquivalence || this.state.confirmation !== false || this.state.edit || this.state.dateEdit || this.state.semesterEdit}
                                                                basic="true"
                                                                circular
                                                                icon="trash alternate"
                                                                size="mini"
                                                                color="red"
                                                                onClick={() => this.setState({ confirmation: index })}
                                                            />}
                                                    />}
                                                </div>}
                                            </div>
                                        }
                                        {this.state.confirmation === index &&
                                            <div
                                                style={{
                                                    marginTop: '5px',
                                                    textAlign: 'center'
                                                }}>
                                                <Fragment>
                                                    <Popup
                                                        content="Obriši"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                loading={this.state.loaderForEditing}
                                                                basic="true"
                                                                circular
                                                                size="mini"
                                                                color="blue"
                                                                icon="check"
                                                                onClick={() => {
                                                                    this.setState({ loaderForEditing: true });
                                                                    this.deleteMark(el.id, el.optLock);
                                                                }}
                                                            />}
                                                    />
                                                    <Popup
                                                        content="Odustani"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                size="mini"
                                                                color="red"
                                                                icon="close"
                                                                onClick={() => {
                                                                    this.setState({ confirmation: false });
                                                                }}
                                                            />}
                                                    />
                                                </Fragment>
                                            </div>
                                        }
                                    </div>
                                </Table.Cell>

                            </Table.Row>))}
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan={'8'} rowSpan="3"/>
                                <Table.HeaderCell
                                    colSpan={isAdmin ? '6' : '4'}>
                                    <h4> Broj položenih ispita: {gradesArray.length}</h4>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell
                                    colSpan={isAdmin ? '6' : '4'}>
                                    <h4> Prosjek ocjena: {average}</h4>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell
                                    colSpan={isAdmin ? '6' : '4'}>
                                    <h4>Ukupno ECTS bodova: {grades.ectsTotal}</h4>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                    :
                    'Nema ocjena za traženog studenta.'
                }
                {isAdmin && (
                    <div style={{
                        marginTop: '10px',
                        textAlign: 'right'
                    }}>
                        <Popup
                            content="Korekcija implementacija predmeta"
                            position="top center"
                            trigger={
                                <Button
                                    basic
                                    loading={this.state.fixCourseImplLoading}
                                    disabled={this.state.fixCourseImplLoading}
                                    color="orange"
                                    icon="wrench"
                                    size="small"
                                    content="Korekcija implementacija predmeta"
                                    onClick={() => this.fixCourseImplementations()}
                                />
                            }
                        />
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentGrades.js